import Icon from 'veui/components/Icon'

Icon.register({
  'file-up': {
    paths: [
      {
        d: 'M256 192a32 32 0 000 64h256a32 32 0 000-64zm438.63 374.63a32 32 0 01-45.26 0L608 525.26V704a32 32 0 01-64 0V525.26l-41.37 41.37a32 32 0 01-45.26-45.26l96-96a32 32 0 0145.26 0l96 96a32 32 0 010 45.26zM384 672H160V96h448v224a32 32 0 0064 0V64a32 32 0 00-32-32H128a32 32 0 00-32 32v640a32 32 0 0032 32h256a32 32 0 000-64zM256 352a32 32 0 000 64h192a32 32 0 000-64z'
      }
    ],
    width: '768',
    height: '768'
  }
})
